import { styled } from 'linaria/react';
import { media } from '../../../../../media';

export const StyledDiv = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 32px;
	margin-top: 40px;
	${media.mobile} {
		grid-template-columns: 1fr;
		gap: 16px;
	}
`;
